<div class="login-wrapper">
    <mat-card class="login-card">
        <div class="logo-area">
            <mat-icon class="app-logo">lock_reset</mat-icon>
            <h1>Set New Password</h1>
        </div>

        <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>New Password</mat-label>
                <input matInput [type]="hide ? 'password' : 'text'" formControlName="password">
                <button mat-icon-button matSuffix (click)="hide = !hide" type="button">
                    <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
                <mat-error *ngIf="resetForm.get('password')?.hasError('required')">Required</mat-error>
                <mat-error *ngIf="resetForm.get('password')?.hasError('minlength')">At least 6 characters</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Confirm Password</mat-label>
                <input matInput type="password" formControlName="confirmPassword">
                <mat-error *ngIf="resetForm.get('confirmPassword')?.hasError('required')">Required</mat-error>
            </mat-form-field>

            <div class="actions">
                <button mat-flat-button color="primary" class="submit-btn" [disabled]="resetForm.invalid || loading">
                    Reset Password
                </button>
            </div>
        </form>
    </mat-card>
</div>